'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PassiveHotel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

var _HotelHeader = require('./HotelHeader.jsx');

var _HotelHeader2 = _interopRequireDefault(_HotelHeader);

var _HotelCompany = require('./HotelCompany.jsx');

var _HotelCompany2 = _interopRequireDefault(_HotelCompany);

var _HotelInfoPanel = require('./HotelInfoPanel.jsx');

var _HotelInfoPanel2 = _interopRequireDefault(_HotelInfoPanel);

var _HotelTypeDescriptionPanel = require('./HotelTypeDescriptionPanel.jsx');

var _HotelTypeDescriptionPanel2 = _interopRequireDefault(_HotelTypeDescriptionPanel);

var _HotelTotalFooter = require('./HotelTotalFooter.jsx');

var _HotelTotalFooter2 = _interopRequireDefault(_HotelTotalFooter);

var _Disclaimer = require('../../../../common/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypeDescription = function getTypeDescription(option) {
  return option.hotelRoom.rateDescription;
};

function PassiveHotel(_ref) {
  var components = _ref.components,
      option = _ref.option,
      optionNumber = _ref.optionNumber;

  var styleHotelCommentContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelCommentContainer');
  var styleHotelComment = (0, _emailStyleTools.textStyles)(components, 'HotelComment');
  var renderDisclaimer = function renderDisclaimer(optionPrice) {
    var text = (0, _basketHelpers.getDisclaimerText)(optionPrice);
    if (text) {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_Disclaimer2.default, {
            padTen: _emailStyleTools.padTen,
            containerStyle: styleHotelCommentContainer,
            textStyle: styleHotelComment,
            text: text
          })
        )
      );
    }
    return '';
  };

  return _react2.default.createElement(
    'table',
    { style: { width: '100%' } },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_HotelHeader2.default, { components: components, text: 'Option ' + (optionNumber + 1) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_HotelCompany2.default, { components: components, text: 'COMPANY NAME Passive' })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_HotelInfoPanel2.default, { components: components, option: option.hotelRoom })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_HotelTypeDescriptionPanel2.default, { components: components, text: getTypeDescription(option) })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(_HotelTotalFooter2.default, { components: components, option: option.optionPrice })
        )
      ),
      renderDisclaimer(option.optionPrice)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Passive/PassiveHotel.jsx
// module id = 1534
// module chunks = 0